import axios from 'axios';
import get from 'lodash.get';
import { from } from 'rxjs';

import { emptyArray } from 'ui-components/default-props/empty';

/**
 * @typedef {import('../../pages/settings/stores/selected-store/shipping-services-tab/service-mapping').ServiceMapping} ServiceMapping
 */

/**
 * @typedef {object} ServiceMappingRequest
 * @property {number} fillMethod
 * @property {string} requestedServiceCode
 * @property {string} [serviceCollectionGuid]
 * @property {string} [serviceId]
 * @property {string} [packageTypeId]
 * @property {string} storeGuid
 */

/**
 * @param {ServiceMappingRequest} params
 * @returns {Promise<void>}
 */
export const mapRequestedService = ({ fillMethod, requestedServiceCode, serviceCollectionGuid, serviceId, packageTypeId, storeGuid }) => {
  return axios
    .post(`/store/${storeGuid}/servicemapping`, {
      fillMethod,
      requestedServiceCode,
      serviceCollectionGuid,
      serviceId,
      packageTypeId,
    })
    .then((response) => {
      return get(response, 'data', undefined);
    });
};

/**
 * @param {string} storeGuid
 * @returns {import('rxjs').Observable<ServiceMapping[]>}
 */
export const getMappingsForStore = (storeGuid) => {
  const request = axios.get(`/store/${storeGuid}/servicemapping`).then((response) => {
    return get(response, 'data', emptyArray);
  });

  const storeServiceMappings$ = from(request);
  return storeServiceMappings$;
};

/**
 * @param {string} storeGuid
 * @returns {Promise<ServiceMapping[]>}
 */
export const fetchMappingsForStore = (storeGuid) => {
  return axios.get(`/store/${storeGuid}/servicemapping`).then((response) => {
    return get(response, 'data', emptyArray);
  });
};

/**
 * @param {ServiceMappingRequest} params
 * @returns {Promise<void>}
 */
export const deleteMappingForStore = ({ fillMethod, requestedServiceCode, serviceCollectionGuid, serviceId, packageTypeId, storeGuid }) => {
  return axios.delete(`/store/${storeGuid}/servicemapping`, {
    data: {
      fillMethod,
      requestedServiceCode,
      serviceCollectionGuid,
      serviceId,
      packageTypeId,
    },
  });
};
